let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("17JTB")).then(() => parcelRequire('3H9Ht'));